export default [
  {
    path: 'criar',
    name: 'new_employee',
    component: () => import('./NewEmployee.vue'),
    meta: {
      name: 'Novo Funcionário',
    },
  },
]
